import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { useDeleteUser } from "../hooks/use-users";
import { toast } from "sonner";

type UserAlertDialogueProps = {
  userId: string;
  onRefetch?: () => void;
};

export const UserAlertDialogue = ({ userId, onRefetch }: UserAlertDialogueProps) => {
  const [selectedUser, setSelectedUser] = useState<string | null>();
  const { deleteUser, loading: loading, error } = useDeleteUser(selectedUser || "");
  const handleDeleteUser = async () => {
    if (selectedUser) {
      try {
        const userDeletedId = await deleteUser();
        if (userDeletedId) {
          toast.success("User has been deleted successfully", {
            style: { color: "#228B22" },
          });
          setSelectedUser(null);
        } else {
          toast.error(error?.message || "Failed to delete user");
        }
        onRefetch?.();
      } catch {
        toast.error("An error occurred");
      }
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button
          className="cursor-pointer bg-transparent border-none p-0 "
          onClick={(e) => {
            e.stopPropagation();
            setSelectedUser(userId);
          }}
          type="button"
        >
          Delete
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Supprimer l'utilisateur</AlertDialogTitle>
          <AlertDialogDescription>
            Êtes-vous sûr de vouloir supprimer cet utilisateur ? Cette action est irréversible.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => setSelectedUser(null)}>Cancel</AlertDialogCancel>
          {loading ? (
            <Button variant="default" disabled>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Deleting...
            </Button>
          ) : (
            <AlertDialogAction onClick={handleDeleteUser}>Delete</AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
